import { jsx as _jsx } from "react/jsx-runtime";
import { memo, Component } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
const scale_device = isSmallUI() ? 0.65 : 1;
const dpr = window.devicePixelRatio ?? 1;
const width = 300;
const cheight = 300 * scale_device;
const vheight = cheight * dpr;
const fheight = vheight * 0.75;
const delay = 350;
function withoutLabel(p) {
    return p;
}
function arrayWithoutLabel(p) {
    return p;
}
class PZAPlotImpl extends Component {
    active_coord;
    tempSelectedId;
    sTime;
    c;
    ctx;
    container_ref;
    constructor(props) {
        super(props);
        this.active_coord = null;
        this.tempSelectedId = -1;
        this.sTime = new Date().getTime();
        this.state = {
            width: width,
            vwidth: width * dpr,
            fwidth: width * dpr * 0.8,
        };
        this.container_ref = props.targetRef;
    }
    componentDidUpdate(prevProps) {
        if (prevProps.width != this.props.width) {
            this.update_width(this.props.width);
        }
        this.drawP();
    }
    update_width = (width) => {
        if (width == null) {
            return;
        }
        this.setState({ width: width, vwidth: width * dpr, fwidth: width * dpr * 0.8 });
        //Перерисовываем canvas
        this.drawP();
    };
    get_p() {
        return this.props.temps ? this.props.temps.map(this.temps2Coords) : [];
    }
    componentDidMount() {
        const ctx = this.c.getContext('2d');
        if (ctx == null)
            throw new Error('Canvas is not supported!?');
        this.ctx = ctx;
        this.c.addEventListener('mousemove', this.cursorMove);
        this.c.addEventListener('touchmove', this.cursorMove);
        this.c.addEventListener('mouseup', this.cursorEnd);
        this.c.addEventListener('touchend', this.cursorEnd);
        this.c.addEventListener('mousedown', this.cursorStart);
        this.c.addEventListener('touchstart', this.cursorStart);
        this.drawP();
    }
    componentWillUnmount() {
        this.c.removeEventListener('mousemove', this.cursorMove);
        this.c.removeEventListener('touchmove', this.cursorMove);
        this.c.removeEventListener('mouseup', this.cursorEnd);
        this.c.removeEventListener('touchend', this.cursorEnd);
        this.c.removeEventListener('mousedown', this.cursorStart);
        this.c.removeEventListener('touchstart', this.cursorStart);
    }
    temps2Coords = ([tx, ty]) => {
        const delta = {
            x: (this.state.vwidth - this.state.fwidth) / 2,
            y: (vheight - fheight) / 2,
        };
        return [
            delta.x + this.state.fwidth * (1 - (tx - -40) / (20 - -40)),
            vheight - delta.y - (fheight * (ty - 20)) / (100 - 20),
            `${tx}, ${ty}`,
        ];
    };
    coords2Temps = ([fx, fy]) => {
        const delta = {
            x: (this.state.vwidth - this.state.fwidth) / 2,
            y: (vheight - fheight) / 2,
        };
        const tx = -40 +
            ((20 - -40) * (this.state.vwidth - (fx + delta.x))) / this.state.fwidth;
        const ty = 20 + ((100 - 20) * (vheight - (fy + delta.y))) / fheight;
        return [tx, ty, `${tx.toFixed(1)}, ${ty.toFixed(1)}`];
    };
    clearField = () => {
        this.ctx.save();
        this.ctx.beginPath();
        this.ctx.rect(0, 0, this.state.vwidth, vheight);
        this.ctx.fillStyle = '#fff';
        this.ctx.fill();
        const xflb = (this.state.vwidth - this.state.fwidth) / 2;
        const yflb = (vheight - fheight) / 2;
        this.ctx.beginPath();
        this.ctx.fillStyle = 'grey';
        this.ctx.font = 12 * dpr + 'px Arial';
        for (let i = 0; i < 7; ++i) {
            const cx = xflb + (this.state.fwidth * i) / 6;
            this.ctx.moveTo(cx + 0.5, yflb);
            this.ctx.lineTo(cx + 0.5, yflb + fheight);
            const num = 20 - 10 * i;
            this.ctx.fillText('' + num + '°', cx - (num === 20 ? 0 : num > 0 ? 10 : num === 0 ? 5 : 20), yflb + fheight + 12 * dpr);
        }
        for (let i = 0; i < 5; ++i) {
            const cy = yflb + (fheight * i) / 4;
            this.ctx.moveTo(xflb, cy + 0.5);
            this.ctx.lineTo(xflb + this.state.fwidth, cy + 0.5);
            const num = 100 - 20 * i;
            this.ctx.fillText('' + num + '°', xflb - (num === 100 ? 25 * dpr : 19 * dpr), cy + 5);
        }
        this.ctx.strokeStyle = '#ccc';
        this.ctx.stroke();
        this.ctx.beginPath();
        this.ctx.rect(xflb, yflb, this.state.fwidth, fheight);
        this.ctx.strokeStyle = '#000';
        this.ctx.stroke();
        this.ctx.restore();
        if (scale_device === 1) {
            this.ctx.fillText('t° вне дома', this.state.fwidth / 2 + 30, 290);
            this.ctx.save();
            this.ctx.translate(15, 150);
            this.ctx.rotate(-0.5 * Math.PI);
            this.ctx.fillText('t° теплоносителя', -40, 0);
            this.ctx.restore();
        }
    };
    drawPoint = ([fx, fy]) => {
        this.ctx.save();
        this.ctx.beginPath();
        this.ctx.arc(fx, fy, 3 * dpr, 0, Math.PI * 2, false);
        this.ctx.fillStyle = '#c4443b';
        this.ctx.fill();
        this.ctx.restore();
    };
    drawSelected = (is_touch) => {
        if (this.tempSelectedId < 0)
            return;
        this.ctx.save();
        this.ctx.beginPath();
        let [fx, fy] = this.get_p()[this.tempSelectedId];
        if (this.active_coord) {
            fx = this.active_coord[0];
            fy = this.active_coord[1];
        }
        this.ctx.arc(fx, fy, 6 * dpr, 0, Math.PI * 2, false);
        this.ctx.fillStyle = 'rgba(196, 68, 59, 0.5)';
        this.ctx.textAlign = 'center';
        this.ctx.font = `${dpr * 12}px sans-serif`;
        const [, , tooltip] = this.coords2Temps([fx, fy]);
        const jump_coord = fx - dpr * 90 < 0;
        this.ctx.fillText(tooltip, is_touch ? (jump_coord ? fx + dpr * 70 : fx - dpr * 70) : fx, fy - dpr * 10);
        this.ctx.fill();
        this.ctx.restore();
    };
    drawP = (is_touch = false) => {
        this.clearField();
        let p = this.get_p()
            .map((pnt, i) => i === this.tempSelectedId && this.active_coord ? this.active_coord : pnt)
            .slice();
        p = this.sortP(p);
        if (p.length === 0)
            return;
        this.ctx.save();
        this.ctx.beginPath();
        this.ctx.strokeStyle = '#125181';
        this.ctx.lineWidth = 1.5 * dpr;
        this.ctx.moveTo(p[0][0], p[0][1]);
        p.forEach((pi) => {
            this.ctx.lineTo(pi[0], pi[1]);
        });
        this.ctx.stroke();
        this.ctx.restore();
        this.drawSelected(is_touch);
        p.forEach((pi) => {
            this.drawPoint(pi);
        });
    };
    drawPRequest = (is_touch) => {
        requestAnimationFrame(() => this.drawP(is_touch));
    };
    getFCoords = (e) => {
        const event = 'touches' in e ? e.touches[0] : e;
        const bounds = this.c.getBoundingClientRect();
        let fx = ((event.clientX - bounds.left) * this.c.width) / bounds.width;
        let fy = ((event.clientY - bounds.top) * this.c.height) / bounds.height;
        const delta = {
            x: (this.state.vwidth - this.state.fwidth) / 2,
            y: (vheight - fheight) / 2,
        };
        if (fx > this.state.vwidth - delta.x)
            fx = this.state.vwidth - delta.x;
        else if (fx < delta.x)
            fx = delta.x;
        if (fy > vheight - delta.y)
            fy = vheight - delta.y;
        else if (fy < delta.y)
            fy = delta.y;
        return [fx, fy];
    };
    sortP = (p) => {
        p.sort((a, b) => {
            let d = a[0] - b[0];
            if (d === 0)
                d = a[1] - b[1];
            return d;
        });
        return p;
    };
    selectPointInP = ([fx, fy]) => {
        const p = this.get_p();
        for (let i = 0; i < p.length; ++i) {
            if (Math.sqrt((fx - p[i][0]) ** 2 + (fy - p[i][1]) ** 2) <= 10 * dpr) {
                return i;
            }
        }
        return -1;
    };
    insertPointInP = (ip) => {
        let p = arrayWithoutLabel(this.get_p());
        if (p.length < 10)
            p.push(withoutLabel(ip));
        p = this.sortP(p);
        this.props.onChange(p ? arrayWithoutLabel(p.map(this.coords2Temps)) : []);
    };
    cursorMove = (e) => {
        e.preventDefault();
        const is_touch = e.type === 'touchmove';
        if (e instanceof MouseEvent && e.buttons === 0)
            this.active_coord = null;
        if (this.active_coord) {
            this.active_coord = this.getFCoords(e);
            this.drawPRequest(is_touch);
        }
        else {
            const tempTempSelectedId = this.tempSelectedId;
            this.tempSelectedId = this.selectPointInP(this.getFCoords(e));
            if (this.tempSelectedId >= 0 || tempTempSelectedId >= 0)
                this.drawPRequest(is_touch);
        }
    };
    cursorEnd = (e) => {
        e.preventDefault();
        if (new Date().getTime() - this.sTime > delay) {
            if (this.active_coord != null && this.tempSelectedId >= 0) {
                const p = arrayWithoutLabel(this.get_p());
                p[this.tempSelectedId] = this.active_coord;
                this.props.onChange(p ? arrayWithoutLabel(p.map(this.coords2Temps)) : []);
            }
            this.active_coord = null;
        }
    };
    cursorStart = (e) => {
        e.preventDefault();
        const fxy = this.getFCoords(e);
        if (new Date().getTime() - this.sTime > delay) {
            this.sTime = new Date().getTime();
            this.tempSelectedId = this.selectPointInP(fxy);
            this.active_coord =
                this.tempSelectedId < 0
                    ? null
                    : [...withoutLabel(this.get_p()[this.tempSelectedId])];
        }
        else {
            if (this.tempSelectedId >= 0) {
                const p = this.get_p();
                if (p.length > 2) {
                    p.splice(this.tempSelectedId, 1);
                    this.tempSelectedId = -1;
                    this.props.onChange(p ? arrayWithoutLabel(p.map(this.coords2Temps)) : []);
                }
            }
            else {
                this.insertPointInP(fxy);
                this.active_coord = null;
            }
        }
        const is_touch = e.type === 'touchstart';
        this.drawPRequest(is_touch);
    };
    set_canvas = (canvas) => {
        this.c = canvas;
    };
    render() {
        return (_jsx("div", { ref: this.container_ref, children: _jsx("canvas", { ref: this.set_canvas, width: this.state.vwidth, height: vheight, style: {
                    width: this.state.width + 'px',
                    height: cheight + 'px',
                    userSelect: 'none',
                } }) }));
    }
}
export const PZAPlot = memo(function PZAPlot(props) {
    const { width, ref } = useResizeDetector({ handleHeight: false });
    return _jsx(PZAPlotImpl, { ...props, targetRef: ref, width: width });
});
